import { render, staticRenderFns } from "./MetaFaturamento.vue?vue&type=template&id=2f69d4e3&scoped=true&"
import script from "./MetaFaturamento.vue?vue&type=script&lang=js&"
export * from "./MetaFaturamento.vue?vue&type=script&lang=js&"
import style0 from "./MetaFaturamento.vue?vue&type=style&index=0&id=2f69d4e3&scoped=true&lang=css&"
import style1 from "./MetaFaturamento.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f69d4e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VIcon,VRow})
